var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTooltipIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_971)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.1818,
    cy: 19.0605,
    r: 13.4545,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5815 5.41848C28.0873 1.92436 23.4415 0 18.5 0C13.5585 0 8.91274 1.92436 5.41848 5.41848C1.92436 8.91274 0 13.5585 0 18.5C0 23.4415 1.92436 28.0873 5.41848 31.5815C8.91274 35.0756 13.5585 37 18.5 37C23.4415 37 28.0873 35.0756 31.5815 31.5815C35.0756 28.0873 37 23.4415 37 18.5C37 13.5585 35.0756 8.91274 31.5815 5.41848ZM18.5 7.29883C20.2931 7.29883 21.752 8.75765 21.752 10.5508C21.752 12.3439 20.2931 13.8027 18.5 13.8027C16.7069 13.8027 15.248 12.3439 15.248 10.5508C15.248 8.75765 16.7069 7.29883 18.5 7.29883ZM23.125 28.9785H13.7305V26.8105H15.248V18.1387H13.8027V15.9707H21.752V26.8105H23.125V28.9785Z",
    fill: "#00944D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_971"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipIcon);
export default __webpack_public_path__ + "static/media/tooltip_icon.378e938af14581cd09af7a8bed45e44f.svg";
export { ForwardRef as ReactComponent };